import { Provider } from '@angular/core';
import { QarepaAuthStorage } from '@qarepa/common';
import { OAuthStorageService } from '@qaroni-app/auth/services/o-auth-storage.service';

export const authStorageProvider = (): Provider => {
  return {
    provide: QarepaAuthStorage,
    useClass: OAuthStorageService,
  };
};
